import { Component, OnInit, Input, OnChanges } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { documentsTypeDisabilities } from "../../../data.constants";
import { config } from "../../../../../../../../environments/config";
import { HasPermissionService } from "../../../../../../employee/service/has-permission/has-permission.service";

@Component({
  selector: "app-documents-upload-typedisabilities",
  templateUrl: "./documents-upload-typedisabilities.component.html",
  styleUrls: ["./documents-upload-typedisabilities.component.scss"],
})
export class DocumentsUploadTypedisabilitiesComponent
  implements OnInit, OnChanges
{
  @Input() noveltyType: string; // Tipo de incapacidad
  @Input() existingFormGroup?: FormGroup; // FormGroup que ya tiene documentos
  @Input() formGroup: FormGroup; // FormGroup principal
  @Input() documentsFromBackend?: any[] = []; // Lista de documentos del backend
  @Input() controlformGroupName: string;
  @Input() hiddenTypeDocumentIds?: number[]; // IDs de tipos de documentos a ocultar
  @Input() visibilityKey: string;
  public documentsTypeDisabilities = documentsTypeDisabilities;
  public apiUrl = config.API_ROOT;
  public isEpicrisisNotRequired: boolean;
  public isAddRemoveDocument: boolean;
  public isLocalStorageValid: boolean;
  public idsToRemove: number[] = []; // Array para almacenar los ids a eliminar

  constructor(
    private fb: FormBuilder,
    public hasPermissionService: HasPermissionService,
  ) {}

  ngOnInit(): void {
    this.isLocalStorageValid =
      localStorage.getItem("token") !== null &&
      localStorage.getItem("token") !== "";
  }

  ngOnChanges() {
    if (!this.existingFormGroup) {
      // Si no se recibe existingFormGroup
      this.getPermissionForDeleteDocuments();
      this.initializeFormArrays(this.documentsFromBackend);
    }
  }

  get selectedNovelty() {
    return this.documentsTypeDisabilities.find(
      (tipo) => tipo.key === this.noveltyType,
    );
  }

  private getVisibleDocuments() {
    if (!this.selectedNovelty) return [];

    const visibilityValue =
      this.visibilityKey ||
      (this.formGroup &&
        this.formGroup.get("eps") &&
        this.formGroup.get("eps").value);


    // const epsControl = this.formGroup && this.formGroup.get("eps");
    // const eps = epsControl ? epsControl.value : null;

    // let documents = this.selectedNovelty.typedocuments.filter((doc: any) => {
    //   if (!doc.onlyForEps || doc.onlyForEps.length === 0) {
    //     return true;
    //   }

    //   return doc.onlyForEps.includes(eps);
    // });

     let documents = this.selectedNovelty.typedocuments.filter((doc: any) => {
       if (!doc.onlyForEps || doc.onlyForEps.length === 0) {
         return true;
       }

       return doc.onlyForEps.indexOf(visibilityValue) !== -1;
     });

    if (this.hiddenTypeDocumentIds && this.hiddenTypeDocumentIds.length > 0) {
      documents = documents.filter(
        (doc: any) => !this.hiddenTypeDocumentIds.includes(doc.id),
      );
    }

    return documents;
  }

  private getPermissionForDeleteDocuments() {
    if (this.documentsFromBackend && this.documentsFromBackend.length > 0) {
      if (this.hasPermission("removed and add document edit disability")) {
        this.isAddRemoveDocument = true;
      } else {
        this.isAddRemoveDocument = false;
      }
    } else this.isAddRemoveDocument = true;
  }

  private initializeFormArrays(documentsFromBackend: any[]) {
    if (this.selectedNovelty) {
      const formGroupKey = this.controlformGroupName;

      if (this.formGroup.get(formGroupKey)) {
        this.formGroup.removeControl(formGroupKey);
      }

      const group = this.fb.group({});

      this.getVisibleDocuments().forEach((doc) => {
        this.isEpicrisisNotRequired =
          this.noveltyType === "work_accident" &&
          doc.formNameArray === "epicrisis";

        const formArray = new FormArray(
          [],
          this.isEpicrisisNotRequired ? null : Validators.required,
        );

        const matchingDocuments = documentsFromBackend.filter(
          (d) => d.list_documents_type_disabilities_id == doc.id,
        );

        matchingDocuments.forEach((d) => {
          formArray.push(new FormControl(d));
        });

        group.addControl(doc.formNameArray, formArray);
      });

      this.formGroup.addControl(formGroupKey, group);
    }
  }

  public getTypedocuments() {
    return this.getVisibleDocuments();
  }

  public getFormGroupName() {
    return this.controlformGroupName;
  }

  public documentArray(documentName: string): FormArray {
    const formGroupKey = this.controlformGroupName;

    // Selecciona el FormGroup correspondiente (existingFormGroup o formGroup)
    const formGroup = this.existingFormGroup
      ? this.existingFormGroup.get(formGroupKey)
      : this.formGroup.get(formGroupKey);

    if (formGroup) {
      // Verificamos la propiedad 'edit' dentro del FormGroup
      const editControl = formGroup.get("edit") as FormControl;

      if (editControl) {
        // Si el valor de 'edit' es 'yes', no se puede agregar ni remover documentos
        if (editControl.value == "yes") {
          this.isAddRemoveDocument = true; // Se puede agregar o remover documentos
        } else {
          this.isAddRemoveDocument = false; // No se puede agregar o remover documentos
        }
      }

      // Ahora obtenemos el FormArray correspondiente según el 'documentName'
      const formArray = formGroup.get(documentName) as FormArray;
      return formArray ? formArray : new FormArray([]);
    }
    // Si no se encuentra el FormGroup, manejar el caso según sea necesario
    console.error("No se encontró el FormGroup con la clave proporcionada.");
    return new FormArray([]); // Evita devolver null
  }

  public onDocumentsChange(event: Event, documentName: string) {
    const input = event.target as HTMLInputElement;

    if (input.files.length > 0) {
      const file = input.files[0]; // Tomamos el primer archivo seleccionado

      const formArray = this.documentArray(documentName);

      // Verificar si ya existe un FormControl con id distinto a 0
      const existingControlIndex = formArray.controls.findIndex(
        (control) => control.value.id === 0,
      );

      if (existingControlIndex !== -1) {
        // Si existe un control con id: 0, significa que es un control de "documento no cargado"
        formArray.removeAt(existingControlIndex); // Eliminamos ese control
      }

      // Ahora agregamos el nuevo archivo al FormArray
      formArray.push(this.fb.control(file)); // Agregar el archivo como un FormControl
    }
  }

  public removeDocument(documentName: string, index: number) {
    const formArray = this.documentArray(documentName); // Obtener el FormArray

    const documentToRemove = formArray.at(index).value; // Obtener el valor del control que se va a eliminar

    // Si el documento tiene un 'id' (es un documento existente)
    if (documentToRemove.id) {
      // Agregar el 'id' del documento a un array de ids a eliminar
      if (!this.idsToRemove) {
        this.idsToRemove = []; // Inicializar el array de ids si no existe
      }

      this.idsToRemove.push(documentToRemove.id);

      // Actualizar el FormGroup principal con el array de ids a eliminar
      this.formGroup.patchValue({ idsToRemove: this.idsToRemove });
    }

    // Eliminar el documento del FormArray
    formArray.removeAt(index);
  }

  public gotoDocument(documentId: number) {
    window.open(
      this.apiUrl +
        "/candidate-disabilities/" +
        documentId +
        "/attachment" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/components/candidate-disabilities/new-candidate-disabilitie/components/documents-upload-typedisabilities/documents-upload-typedisabilities.component.ts